import { IconAngleLeft } from '@iwoca/icons';
import Cookies from 'js-cookie';

import { SIGNUP_STEPS_DIRECT_UK } from '../../constants';
import { useSignupRouterUK } from '../../hooks/useSignupRouter/useSignupRouterUK';
import { useGetStateQuery } from '../../lendingApi/lendingApiQueries';
import { TSignupStepsUK } from '../../types';
import { Button } from '../Button/Button';

/**
 * BackToStep component is only rendered for direct customer UK signup.
 */
const BackToStep = () => {
  const { navigateSignup, currentStep } = useSignupRouterUK();
  const { isStateFetching, isStateLoading } = useGetStateQuery();
  const tempShowSplitTestAI = Cookies.get('iwoca-ai-questions');

  const getPreviousStep = (currentStep: string): TSignupStepsUK => {
    const SIGNUP_STEPS = tempShowSplitTestAI
      ? SIGNUP_STEPS_DIRECT_UK
      : SIGNUP_STEPS_DIRECT_UK.filter((step) => step !== 'company-questions');

    const currentStepIndex = SIGNUP_STEPS.findIndex(
      (step) => step === currentStep,
    );

    if (currentStep === 'check') {
      return 'business';
    }

    if (currentStep === 'documents') {
      return 'applicant';
    }

    if (currentStepIndex > 0) {
      return SIGNUP_STEPS[currentStepIndex - 1];
    }

    return '';
  };

  if (currentStep === 'new') return null;

  const renderButtonText = () => {
    return currentStep === 'documents' ? 'Back to details' : 'Back a step';
  };

  return (
    <Button
      size={currentStep === 'documents' ? 'medium' : 'small'}
      variant="tertiary"
      onClick={() => navigateSignup({ route: getPreviousStep(currentStep) })}
      disabled={isStateFetching || isStateLoading}
    >
      <IconAngleLeft />
      {renderButtonText()}
    </Button>
  );
};

export default BackToStep;
